import { createContext,useContext } from "react";
import type { ReadingActor } from "../../../shared/child-profile";
export type { ReadingActor } from "../../../shared/child-profile";
export type ReadingApi = { actor: ReadingActor; fetch: typeof fetch; dispose: () => void; activate: () => void };
export const ReadingApiContext = createContext<ReadingApi | null>(null);
export function useReadingApi() {
  const api = useContext(ReadingApiContext);
  if (!api) throw new Error("reading_context_missing");
  return api;
}
export function createReadingApi(actor: ReadingActor, changed: () => void): ReadingApi {
  const pending = new Set<AbortController>();
  let disposed = false;
  const dispose = () => { disposed = true; for (const controller of pending) controller.abort(); pending.clear(); };
  return { actor, dispose, activate: () => { disposed = false; }, fetch: async (input, init = {}) => {
    if (disposed) throw new DOMException("Aborted", "AbortError");
    const controller = new AbortController();
    const abort = () => controller.abort();
    init.signal?.addEventListener("abort", abort, { once: true });
    if (init.signal?.aborted) controller.abort();
    pending.add(controller);
    const headers = new Headers(init.headers);
    headers.set("X-Reading-Actor", actor.actor);
    if (actor.child) headers.set("X-Reading-Child-Id", actor.child.id);
    try {
      const response = await fetch(String(input).replace(/^\/api\/(?!reading\/)/, "/api/reading/"), { ...init, headers, signal: controller.signal, cache: "no-store" });
      if (response.status === 409 && (await response.clone().json()).error === "reader_changed") { dispose(); changed(); throw new DOMException("Reader changed", "AbortError"); }
      return response;
    } finally { pending.delete(controller); init.signal?.removeEventListener("abort", abort); }
  } };
}
